import URLS from '../../configs/urls';

export default function tuileNative() {
    const scriptTuileTag = window && document.createElement('script');
    const scriptTuileFreeskreenTag = window && document.createElement('script');

    scriptTuileTag.innerHTML = `
        try {
            window._FskCFC = "OTk1TTMyMjAyMjEyMDUxNTQwMjI=";
            window._FskKeyValues = "%%PATTERN:TARGETINGMAP%%";
        } catch(e) {}
    `;
    document.body.appendChild(scriptTuileTag);

    scriptTuileFreeskreenTag.setAttribute('src', URLS.freeskreen);
    document.body.appendChild(scriptTuileFreeskreenTag);
}
